// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = '2025.5.0';
export const SHA = 'eeb0f5e87c3caa9dfc96f03810d5a0cadc7aebcb';
